import React, { useState } from "react";
import { Modal, Spin } from "antd";

import DashboardPagePaymentDetail from "./Payments/DashboardPagePaymentDetail";
import PaymentFirstPage from "./Payments/PaymentFirstPage";
import PaymentDoneMulti from "./Payments/PaymentDoneMulti";
import PaymentFaild from "./Payments/PaymentFaild";
import PaymentDone from "./Payments/PaymentDone";

export default function PaymentReportModal({
  isGettingHelcimApprovedCard,
  setShowPaymentReportModal,
  showPaymentReportModal,
  setCurrentPaymentStep,
  currentPaymentStep,
  setPaymentType,
  payResult1,
  payResult,
  response2,
  response,
}) {
  const [selectedPayment, setSelectedPayment] = useState([]);

  const handleCloseDetailModal1 = () => {
    setShowPaymentReportModal(false);
    setSelectedPayment([]);
    setPaymentType(null);
    setCurrentPaymentStep(1);

    // console.log(this.state.paymentType);
    sessionStorage.removeItem("treatment.currentStep");
    localStorage.removeItem("treatment.paymentId");
    localStorage.removeItem("treatment.wizard_recurring_interval_count");
    localStorage.removeItem("treatment.interval Id");
    localStorage.removeItem("treatment.type");
  };

  const handleRetryPayment = () => {
    setCurrentPaymentStep(1);
    setSelectedPayment({ id: selectedPayment, status: "pending" });
  };

  const onPaymentTypeSelected = (paymentType) => {
    setPaymentType(paymentType);
    setCurrentPaymentStep(2);
  };

  const handleNextStep = () => {
    setCurrentPaymentStep((prevStep) => Number(prevStep.current) + 1);
    sessionStorage.setItem("currentStep", currentPaymentStep.toString()); // Persist step change
  };

  return (
    <Modal
      open={showPaymentReportModal}
      title="Payment Details"
      onCancel={() => handleCloseDetailModal1()}
      footer={null} // This line ensures no footer (and thus no buttons) is displayed
      style={{ minWidth: 568 }}
      className="modal-payment"
      centered
    >
      {isGettingHelcimApprovedCard ? ( // Show loading spinner when loading is true
        <div style={{ textAlign: "center", display: "flex", flexDirection: "column" }}>
          <Spin size="large" />
          Processing Payment
        </div>
      ) : (
        <>
          {selectedPayment && currentPaymentStep === 1 ? (
            selectedPayment.status === "pending" ? (
              <PaymentFirstPage onNextStep={handleNextStep} selectediD={selectedPayment.id} onPaymentTypeSelected={onPaymentTypeSelected} />
            ) : (
              <DashboardPagePaymentDetail selectediD={selectedPayment.id} />
            )
          ) : (
            <></>
          )}

          {currentPaymentStep === 2 && payResult ? <PaymentDone /> : <></>}
          {currentPaymentStep === 2 && payResult1 ? <PaymentDoneMulti /> : <></>}
          {currentPaymentStep === 2 && payResult === false ? <PaymentFaild response={response} onRetry={handleRetryPayment} /> : <></>}
          {currentPaymentStep === 2 && payResult1 === false ? <PaymentFaild response={response2} onRetry={handleRetryPayment} /> : <></>}
        </>
      )}
    </Modal>
  );
}
